import { Component, Input, OnInit, OnDestroy } from '@angular/core';

@Component({
    selector: 'app-slider',
    templateUrl: './slider.component.html',
    styleUrls: ['./slider.component.scss']
})
export class SliderComponent implements OnInit, OnDestroy {
    @Input() slides: string[] = [];
    currentSlide = 0;
    sliderInterval: any;
    isPaused = false;

    ngOnInit() {
        this.startSlider();
    }

    ngOnDestroy() {
        this.stopSlider();
    }

    nextSlide() {
        this.currentSlide = (this.currentSlide + 1) % this.slides.length;
    }

    prevSlide() {
        this.currentSlide =
            this.currentSlide === 0 ? this.slides.length - 1 : this.currentSlide - 1;
    }

    goToSlide(index: number) {
        this.currentSlide = index;
    }

    startSlider() {
        this.sliderInterval = setInterval(() => {
            this.nextSlide();
        }, 5000);
    }

    stopSlider() {
        if (this.sliderInterval) {
            clearInterval(this.sliderInterval);
        }
    }

    toggleSlider() {
        this.isPaused = !this.isPaused;
        if (this.isPaused) {
            this.stopSlider();
        } else {
            this.startSlider();
        }
    }
}